/**
 * Account → Graphical requests API: the developer documentation of the public
 * API and the account's keys / webhook. api/graphical-requests(/:section),
 * section = a documentation chapter or "keys". Role DASHBOARD_GRAPHICALREQUESTS_API.
 */
define('apiDocsRouter',[
  'require',
  'exports',
  'module',
  'marionette',
  'app',
  'settings',
  'itemPagesNameMixin',
  'rolesMixin'
], function (require, exports, module, Marionette, App, Settings, ItemPagesNameMixin, RolesMixin) {
  'use strict';

  var ApiDocsRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'api/graphical-requests': 'showPage',
      'api/graphical-requests/:section': 'showPage'
    }
  });

  var API = {
    showPage: function (section) {
      require([
        'apiDocsPageView',
        'contentShowController'
      ], function (PageView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          // Same gate as the menu entry: without the API role, back to the home page.
          if ((Settings.get('cAccountRoles') || {})[RolesMixin.DASHBOARD_GRAPHICALREQUESTS_API] !== true) {
            App.navigate('', {trigger: true});
            return;
          }
          App.currentUrl = 'api/graphical-requests' + (section ? '/' + section : '');
          var region = App.regions.getRegion('main').currentView.getRegion('content');
          if (region.currentView instanceof PageView) {
            region.currentView.go(section);
          } else {
            region.show(new PageView({section: section}));
          }
          App.execute('set:active:nav:item', ItemPagesNameMixin.API_GRAPHICAL_REQUESTS);
        });
      });
    }
  };

  App.on('before:start', function () {
    new ApiDocsRouter({controller: API});
  });

  module.exports = ApiDocsRouter;
});

